import { Youtube, Instagram, Facebook, Music2 } from "lucide-react";
import { useContent } from "../content/ContentContext";
import { scrollToId } from "../hooks/useLenis";

const NAV = [
  { label: "Home", href: "#top" },
  { label: "Episodes", href: "#episodes" },
  { label: "Characters", href: "#family" },
  { label: "About", href: "#story" },
  { label: "Watch", href: "#watch" },
  { label: "Contact", href: "#join" },
];

export const Footer = () => {
  const { SOCIALS } = useContent();
  const SOCIAL_ICONS = [
    { id: "youtube", href: SOCIALS.youtube, Icon: Youtube },
    { id: "tiktok", href: SOCIALS.tiktok, Icon: Music2 },
    { id: "instagram", href: SOCIALS.instagram, Icon: Instagram },
    { id: "facebook", href: SOCIALS.facebook, Icon: Facebook },
  ];

  return (
    <footer className="relative bg-[#070707] border-t border-white/10 py-16 md:py-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div>
            <p className="font-display text-2xl md:text-3xl tracking-[0.18em]" data-testid="footer-brand">
              WE NEED <span className="italic text-gold-light">TO TALK</span>
            </p>
            <p className="font-quote italic text-base text-smoke mt-3" data-testid="footer-tagline">
              "Real Conversations. Real Lessons. Real Life."
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3" aria-label="Footer navigation">
            {NAV.map((n) => (
              <button
                key={n.label}
                onClick={() => (n.href === "#top" ? window.__lenis?.scrollTo(0, { duration: 1.4 }) : scrollToId(n.href))}
                className="text-[11px] tracking-[0.26em] uppercase text-smoke hover:text-gold-light transition-colors duration-300"
                data-testid={`footer-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </button>
            ))}
          </nav>
          <div className="flex gap-3">
            {SOCIAL_ICONS.map(({ id, href, Icon }) => (
              <a
                key={id}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={id}
                className="w-10 h-10 rounded-full border border-white/10 hover:border-gold/60 flex items-center justify-center text-smoke hover:text-gold-light transition-colors duration-300"
                data-testid={`footer-social-${id}`}
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
        <div className="h-px bg-white/10 my-10" />
        <p className="text-[11px] tracking-[0.2em] uppercase text-smoke/70 text-center" data-testid="footer-copyright">
          © 2026 WE NEED TO TALK. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};
